import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import {
  fullstorySelectors,
  elementPropertyRulesSelectors,
  ElementPropertyRulesRequestActions,
} from '@fullstory/redux';

const { getOrgId } = fullstorySelectors;
const { getAllElementPropertyRulesLoading, getAllElementPropertyRules } =
  elementPropertyRulesSelectors;

export const useElementPropertyRules = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(getOrgId);

  React.useEffect(() => {
    dispatch(ElementPropertyRulesRequestActions.getAllElementPropertyRules(orgId));
  }, [dispatch, orgId]);

  const loading = useSelector(getAllElementPropertyRulesLoading);
  const allElementPropertyRules = useSelector(getAllElementPropertyRules);

  return {
    loading,
    allElementPropertyRules,
  };
};
